import classNames from "classnames";
import { isNil } from "lodash";
import { memo } from "react";
import styles from "./index.module.less";

const AiTagComponent = memo(
  function AiTag({
    pin,
    size = "md",
    className,
    hide,
    style,
  }: {
    pin: any;
    size?: "lg" | "sm" | "md";
    className?: string;
    hide?: boolean;
    style?: React.CSSProperties;
  }) {
    if (!isNil(pin?.extra?.aigc)) {
      return (
        <div
          className={classNames(
            styles.ai,
            styles[size] ?? "",
            hide ? styles.hide : "",
            className
          )}
          style={style}
        ></div>
      );
    }
    return null;
  },
  (prevProps, nextProps) => {
    return (
      prevProps.pin?.extra?.aigc === nextProps.pin?.extra?.aigc &&
      prevProps.hide === nextProps.hide &&
      prevProps.style === nextProps.style
    );
  }
);

export default AiTagComponent;
